import { FeatureFlagKey, featureFlagsConfig } from '~/app/conf/feature-flag-config'
import { featureFlagEnv, FeatureFlagService } from './feature-flag-service'

/**
 * feature flag를 확인하는 함수
 *
 * @param featureName - feature flag key
 * @returns feature flag가 활성화되어 있는지 여부
 */
export const isFeatureEnabled = (featureName: FeatureFlagKey) => {
  const featureFlagService = new FeatureFlagService(featureFlagsConfig, featureFlagEnv)

  return featureFlagService.isFeatureEnabled(featureName)
}
